import connect from './connect';
import VideoClipWizard from './VideoClipWizard';

const connectedWizard = connect(VideoClipWizard);
export default connectedWizard;
